<template>
    <div class="Public-HeaderBar">
        <div class="Public-Line" id="Line">
        </div>
        <div class="Public-Header">
            <p class="Title">Love丶FFC's Blog</p>
        </div>
<!--        <div class="Public-Menu" v-on:click="Show" id="Menu"><i class="fa fa-navicon"></i></div>-->
<!--        <div class="Public-Menu-Content" id="Menucontent" :style="MenuStyle">-->
<!--            <div class="Headimage"></div>-->
<!--            <form class="Search" role="search" method="get" id="searchform" action="https://www.loveffc.cn/">-->
<!--                <input type="text" :placeholder="Header.Search+'...'" class="Content" value="">-->
<!--                <input type="submit" :value="Header.Search" class="Submit">-->
<!--            </form>-->
<!--            <ul>-->
<!--                <li id="Index">-->
<!--                    <router-link to="/"><i class="fa fa-home"></i>{{ Header.Home }}</router-link>-->
<!--                </li>-->
<!--                <li id="Album">-->
<!--                    <router-link to="/Album"><i class="fa fa-picture-o"></i>{{ Header.Album }}</router-link>-->
<!--                </li>-->
<!--                <li id="About">-->
<!--                    <router-link to="/About"><i class="fa fa-user-circle-o"></i>{{ Header.About }}</router-link>-->
<!--                </li>-->
<!--                <li id="Link">-->
<!--                    <router-link to="/Link"><i class="fa fa-users"></i>{{ Header.Link }}</router-link>-->
<!--                </li>-->
<!--                <li id="TimeList">-->
<!--                    <router-link to="/TimeList"><i class="fa fa-hourglass-half"></i>{{ Header.TimeList }}</router-link>-->
<!--                </li>-->
<!--            </ul>-->
<!--            <div class="Mark">-->
<!--                <a href="mailto:cswangjishu@hotmail.com" v-on:click="Open('M')" :title="Header.Mark.Mail-->
<!--"><i class="fa fa-envelope"></i></a>-->
<!--                <a onclick="Open('G')" href="https://github.com/JiShuWang" target="_blank"-->
<!--                   :title="Header.Mark.GitHub"><i class="fa fa-github"></i></a>-->
<!--                <a onclick="Open('Q')" :title="Header.Mark.QQ" href="/Image/QQQRCode.jpg"><i class="fa fa-qq"></i></a>-->
<!--                <a onclick="Open('W')" :title="Header.Mark.WeChat" href="/Image/WeChatQRCode.jpg"><i class="fa fa-weixin"></i></a>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
var MenuStyle = "";//控制导航栏内容的显示
var MenuClickCount = true;//判断点击次数
export default {
    name: "PublicHeader",
    data() {
        return {
            MenuStyle: MenuStyle,
        }
    },
    methods: {
        Show: function (Name) {
            if (MenuClickCount) {
                this.MenuStyle = "display:block";
                MenuClickCount = false;
            } else {
                this.MenuStyle = "display:none";
                MenuClickCount = true;
            }
        },
        Open: function (Mark) {
            if (Mark === "M") {
                window.alert("欢迎你联系我。\n我的邮箱:cswangjishu@hotmail.com");
            } else if (Mark === "G") {
                window.alert("GitHub栏目长期更新，即将跳转JiShu Wang的GitHub！");
            } else if (Mark === "W") {
                window.alert("欢迎添加我的微信，微信号:WJS347700498，也可以扫码添加。");
            } else if (Mark === "Q") {
                window.alert("欢迎添加我的QQ，QQ号:347700498，也可以扫码添加。");
            }
        },
    },
    watch:{
        $route(to,from) {
            this.MenuStyle = "display:none";
            MenuClickCount = true;
        }
    },
    computed: {
        Header: function () {
            return this.$store.state.LANGUAGECONTENT.Header;
        }
    }
}
</script>